import { useParams } from "@tanstack/react-router";

export function useKitUuid(): string | null {
  let { kitUuid } = useParams({ strict: false }) as { kitUuid?: string };

  if (Array.isArray(kitUuid)) {
    kitUuid = kitUuid[0];
  }

  return kitUuid ?? null;
}
